<template>
  <div class="about-section section-space--inner--120">
    <div class="container">
      <div class="row row-25 align-items-center">
        <div class="col-lg-6 col-12 mb-30">
          <div class="about-image-two">
            <img
              :src="$backendPublic + data.extras.top_section_image"
              :alt="data.extras.top_section_title"
            />
            <!-- <span class="video-popup">
              <silentbox-single :src="data.youtubeLink">
                <i class="ion-ios-play-outline"></i>
              </silentbox-single>
            </span> -->
          </div>
        </div>
        <div class="col-lg-6 col-12 mb-30">
          <div class="about-content-two">
            <!-- <h3>{{ data.aboutUs.subTitle }}</h3> -->
            <h1 v-html="data.extras.top_section_title"></h1>
            <!-- <h4>{{ data.aboutUs.shortDesc }}</h4> -->
            <p v-html="data.extras.top_section_content"></p>
            <!-- <router-link
              to="service"
              class="ht-btn--default ht-btn--default--dark-hover section-space--top--20"
              >خدمات ما</router-link
            > -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import data from "../../data/about.json"
export default {
  props: ["data"],

  data() {
    return {
      // data,
    }
  },

  mounted() {
    console.log("this.pageData")

    console.log(this.data)
  },
}
</script>
